<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Movimiento E/S SKU
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consultas</span>
      <span> /</span>
      <span class="grey-text">Inventario</span>
      <span> /</span>
      <span>Movimiento E/S SKU</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsBodega" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Bodega" formControlName="bodega">
            </mdb-select>
            <label>Bodega</label>
          </div>
        </div>
        <div class="col" style="max-width: 100px;">
          <div class="md-form">
            <mdb-select [options]="optionsMonth" [filterEnabled]="true" [highlightFirst]="false" placeholder="Mes"
              formControlName="mes"></mdb-select>
            <label>Mes</label>
          </div>
        </div>
        <div class="col" style="max-width: 100px;">
          <div class="md-form">
            <mdb-select [options]="optionsYear" [filterEnabled]="true" [highlightFirst]="false" placeholder="Año"
              formControlName="anho"></mdb-select>
            <label>Año</label>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form mt-3">
            <input value="" type="text" id="codProduct" class="form-control" placeholder="000" #codProduct
              formControlName="sku" />
            <label for="codProduct">Código de producto</label>
          </div>
        </div>
        <div class="col d-flex" style="max-width: 300px;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarProducto()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;" *ngIf="productoSeleccionado">
            {{ productoSeleccionado.descripcion}}
          </h6>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsFormato" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Formato" formControlName="formato">
            </mdb-select>
            <label>Formato</label>
          </div>
        </div>
      </div>

   
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">

    <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

    <div class="table-responsive" *ngIf="listaMovimientos">

      <app-no-data-alert *ngIf="listaMovimientos?.length === 0">
      </app-no-data-alert>

      <table class="table table-striped table-hover table-sm align-middle" >
        <thead class="grey lighten-2">
          <tr>
            <th rowspan="2" scope="col">Fecha</th>
            <th rowspan="2" scope="col">SKU</th>
            <th rowspan="2" scope="col">Producto</th>
            <th rowspan="2" scope="col">Bodega</th>
            <th rowspan="2" scope="col">Doc. Ref.</th>
            <th colspan="2" scope="col" class="text-center">Ingresos</th>
            <th colspan="2" scope="col" class="text-center">Salidas</th>
            <th colspan="2" scope="col" class="text-center">Saldos</th>
          </tr>
          <tr>
            <th class="text-center">Cajas</th>
            <th class="text-center">Unid.</th>
            <th class="text-center">Cajas</th>
            <th class="text-center">Unid.</th>
            <th class="text-center">Cajas</th>
            <th class="text-center">Unid.</th>
          </tr>
        </thead>

        <tbody *ngIf="listaMovimientos?.length > 0">
          <ng-container *ngFor="let mov of listaMovimientos">
            <!-- FILA SALDO INICIAL -->
            <!-- <tr *ngIf="mov.esFilaSaldoInicial" class="font-weight-bold">
              <td></td>
              <td><span *ngIf="!conProducto">{{ mov.sku }}</span></td>
              <td><span *ngIf="!conProducto">{{ mov.producto_descripcion }}</span></td>
              <td [attr.colspan]="conProducto ? 4 : 6" class="text-right">Saldo Anterior:</td>
              <td class="border-left border-right text-right">{{mov.saldoCantidad}}</td>
              <td class="border-right text-right">{{mov.saldoFraccion}}</td>
            </tr> -->
            <!-- FILA MOVIMIENTO -->
            <tr *ngIf="!mov.esFilaSaldoInicial">
              <td>{{mov.fecha_movimiento | fecha}}</td>
              <td>{{mov.sku}}</td>
              <td>{{mov.producto_descripcion}}</td>
              <td>{{mov.bodega_nombre}}</td>
              <td>{{mov.documento}}</td>
              <td class="border-left border-right text-right">{{mov.ingresosCantidad}}</td>
              <td class="border-right text-right">{{mov.ingresosFraccion}}</td>
              <td class="border-left border-right text-right">{{mov.salidasCantidad}}</td>
              <td class="border-right text-right">{{mov.salidasFraccion}}</td>
              <td class="border-left border-right text-right">{{mov.saldoCantidad}}</td>
              <td class="border-right text-right">{{mov.saldoFraccion}}</td>
            </tr>
          </ng-container>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="exportarExcel()">
      Excel
    </button>

    <!-- <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm">
      PDF
    </button> -->
  </div>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [showFiltroActivoInactivo]="false" (onSelect)="onProductoSeleccionado($event)"
  (onNotFound)="onProductoNoEncontrado()">
</app-modal-seleccionar-producto>